import { gql } from "@apollo/client";

const ActiveUserDevices = gql`
  query allUserDevices($userId: UUID!) {
    allUserDevices(condition: { userAppId: $userId }, orderBy: DEVICE_ID_ASC) {
      nodes {
        id
        deviceId
        deviceByDeviceId {
          deviceName
        }
      }
    }
  }
`;

const hash = "584d27d61322415ebf90cc7b5b339548e1fd71b3a59a8840bc99f9c43c47db26";

export { ActiveUserDevices, hash };
